module.exports = __webpack_public_path__ + "static/home-image-2-98914f000e4e180e59f9ff43cca449ed.jpg";